module.exports = __webpack_public_path__ + "92dc61e5.png";